import { notes } from './notes'

export const handlers = [...notes]
